module.exports = __webpack_public_path__ + "static/img/Horticulturae 10a.c691e17e.webp";